export const venueForPage = ({ page, menus }) => {
    // fetch the venue and navigation structure for this page
    const venueObject = (page?.venueFields && page.venueFields.venue) || { venue_fields: { hasCustomNavigationMenu: false } }
    const venue = { ...venueObject }

    const venueHasCustomNavigation = venue ? venue.venue_fields.hasCustomNavigationMenu : false
    const menuId = venueHasCustomNavigation ? parseInt(venue.venue_fields.venueNavigationMenuId, 10) : null

    let theme
    switch (venue.slug) {
        case "pickfords-house":
            theme = "PH"
            break
        case "museum-of-making":
            theme = "MOM"
            break
        case "museum-art-gallery":
            theme = "MAG"
            break
        default:
            theme = "DM"
            break
    }

    let menu
    if (menuId) {
        menu = menus.results.find((menu) => menu.id === menuId)
    } else {
        menu = menus.results[0]
    }

    venue.navigation = menu
    venue.theme = theme

    return venue
}
